import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    Schedulable,
    SchedulableHeader,
    SchedulableID,
} from "userful-chronos-app-common-js/dist/models/schedule/schedulable";

export interface EventsState {
    schedulables: Schedulable[];
}

const initialState: EventsState = {
    schedulables: [],
};

export const schedulablesSlice = createSlice({
    name: "schedulablesSlice",
    initialState,
    reducers: {
        setSchedulables: (state, action: PayloadAction<SchedulableHeader[]>) => {
            if (action.payload.length > 0) {
                state.schedulables = [...action.payload];
            }
        },
        notifySchedulableAdded: (state, action: PayloadAction<SchedulableHeader>) => {
            state.schedulables = [...state.schedulables, { ...action.payload }];
        },
        notifySchedulableUpdated: (state, action: PayloadAction<SchedulableHeader>) => {
            const foundIndex = state.schedulables.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex >= 0) {
                state.schedulables = [
                    ...state.schedulables.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.schedulables.slice(foundIndex + 1),
                ];
            }
        },
        notifySchedulableRemoved: (state, action: PayloadAction<SchedulableID>) => {
            state.schedulables = state.schedulables.filter((item) => item.id.value !== action.payload.value);
        },
    },
});

export const schedulablesActions = schedulablesSlice.actions;

export default schedulablesSlice.reducer;
